import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'react-bootstrap';
import cn from 'classnames';

/**
 * Toast
 */
class Toast extends React.Component {
	constructor(props, context) {
		super(props, context);
		this.onActive = this.onActive.bind(this);
		this.onDeactive = this.onDeactive.bind(this);
		this.onDismissing = this.onDismissing.bind(this);
		this.onDismiss = this.onDismiss.bind(this);

		this.state = {
			show: true,
			hiding: false
		};
	}

	componentDidMount() {
		this.startDismissTimer();
	}

	/**
	 * Start timer to hide the toast.
	 */
	startDismissTimer() {
		this.cancelDismissTimer();
		this.setState({
			timer: setTimeout(() => this.onDismissing(), this.props.time)
		});
	}

	/**
	 * Cancel timer that will hide the toast.
	 */
	cancelDismissTimer() {
		const { timer } = this.state;
		timer && clearTimeout(timer);
		this.setState({
			timer: null
		});
	}

	/**
	 * Animate the dismiss.
	 */
	onDismissing() {
		this.cancelDismissTimer();
		this.setState(
			{ hiding: true }
		);
		// Wait animationDuration to allow animation to play
		setTimeout(
			() => { this.onDismiss(); },
			this.props.animationDuration
		);
	}

	onDismiss() {
		this.cancelDismissTimer();
		const { onClose } = this.props;
		this.setState(
			{
				show: false,
				hiding: false
			},
			() => onClose && onClose()
		);
	}

	/**
	 * When the toast is active (focused or moused over) then halt
	 * the dismiss timer.
	 */
	onActive() {
		this.cancelDismissTimer();
	}

	/**
	 * Restart the dismiss timer when the toast loses focus.
	 */
	onDeactive() {
		if (this.state.show) {
			this.startDismissTimer();
		}
	}

	render() {
		const { animationDuration, bsStyle, children, className } = this.props;
		if (this.state.show) {
			return (
				<div className={cn('toast', className)}>
					<div
						className={cn('slice', { hiding: this.state.hiding })}
						style={{
							animationDuration: `${animationDuration}ms`
						}}
					>
						<Alert
							className={cn({ hiding: this.state.hiding })}
							onMouseEnter={this.onActive}
							onMouseLeave={this.onDeactive}
							onFocus={this.onActive}
							onBlur={this.onDeactive}
							bsStyle={bsStyle}
							onDismiss={this.onDismissing}
						>
							{children}
						</Alert>
					</div>
				</div>
			);
		}
		return null;
	}
}

Toast.propTypes = {
	/**
	 * The amount of milliseconds to display the toast for.
	 */
	time: PropTypes.number,

	/**
	 * The time in milliseconds for the slide in/out animation to play.
	 */
	animationDuration: PropTypes.number,

	/**
	 * The style of the toast alert, one of: "success", "warning", "danger", "info"
	 */
	bsStyle: PropTypes.string,

	/**
	 * The callback fired when the toast closes.
	 */
	onClose: PropTypes.func,

	/**
	 * Class name of the toast component.
	 */
	className: PropTypes.string
};

Toast.defaultProps = {
	time: 5000,
	animationDuration: 500,
	bsStyle: 'success'
};

export default Toast;
